import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPoolRoomStatus.ts
var t = () => e("poolRoomStatus");
//#endregion
export { t as useTrPoolRoomStatus };
